import {
	Component,
	Inject,
	Injector,
	ViewContainerRef,
	ComponentFactoryResolver,
	OnInit,
	OnDestroy,
	ElementRef,
	ReflectiveInjector,
	ComponentRef,
	ViewChild,
	Renderer,
	HostListener
} from '@angular/core';

import { TooltipContainerDirective } from './tooltip-container.directive';


export class TooltipComponent implements OnInit, OnDestroy {
	// currently we support only top alignment of the tooltip

	 public tooltipContainer;
	 public customComponentHost: ViewContainerRef;
	 public textHostElmRef: ElementRef;

	public bottom: string = 'auto';
	public top: string = 'auto';
	public left: string = 'auto';
	public right: string = 'auto';
	public isVisible: boolean = false;
	public position: string = 'top';
	public maxWidth: string = '250';
	public isHovered: boolean = false;

	private customComponentRef: ComponentRef<any>;

	constructor(
		 private config,
		private renderer: Renderer,
		private injector: Injector,
		private resolver: ComponentFactoryResolver) { }

	// Lifecycle Hooks
	public ngOnInit(): void {
		this.fetchContent();
		setTimeout(() => {
			this.calculatePosition();
		});
	}

	public ngOnDestroy(): void {
		if (this.customComponentRef) {
			this.customComponentRef.destroy();
			this.customComponentRef = null;
		}
	}

	
	public onMouseEnter(): void {
		this.isHovered = true;
	}

	
	public onMouseLeave(): void {
		this.isHovered = false;
	}

	private calculatePosition(): void {
		const innerHeight = window.innerHeight;
		const { left: hostLeft, bottom: hostBottom, top: hostTop, width: hostWidth, height: hostHeight, right: hostRight } = this.config.host.getBoundingClientRect();
		const { width: tooltipWidth, height: tooltipHeight } = this.tooltipContainer.nativeElement.getBoundingClientRect();

		switch (this.position) {
			case 'right':
				this.bottom = `${innerHeight - hostBottom + (hostHeight / 2 - tooltipHeight / 2)}px`;
				this.left = `${hostLeft + hostWidth + 10}px`;
				this.isVisible = true;

				break;
			case 'bottom':
				this.top = `${hostTop + hostHeight + 10}px`;
				this.left = `${hostLeft + (hostWidth / 2 - tooltipWidth / 2)}px`;
				this.isVisible = true;

				break;
			default:
				// top
				this.bottom = `${innerHeight - hostBottom + hostHeight + 10}px`;
				this.left = `${hostLeft + (hostWidth / 2 - tooltipWidth / 2)}px`;
				this.isVisible = true;

				break;
		}
	}

	private fetchContent(): void {
		if (this.config['position']) {
			this.position = this.config['position'];
		}
		if (this.config['maxWidth']) {
			this.maxWidth = this.config['maxWidth'];
		}
		if (!this.config['content']) {
			return;
		}

		// fetch content
		if (typeof this.config['content'] === 'string') {
			// add the text/html to component
			this.renderer.invokeElementMethod(this.textHostElmRef.nativeElement, 'insertAdjacentHTML', ['beforeend',  this.config['content']]);

			return;
		}

		// is a component - append it
		let optionsToPass: any  = {
			provide: 'context',
			useValue: {
				data: this.config.data,
			}
		};
		const injector = ReflectiveInjector.resolveAndCreate([optionsToPass], this.injector);
		let factory = this.resolver.resolveComponentFactory(this.config['content']);
		this.customComponentRef = this.customComponentHost.createComponent(factory, undefined, injector);
	}
static ctorParameters() { return [ { type: undefined, decorators: [{ type: Inject, args: ['tooltipConfig'] }] }, { type: Renderer }, { type: Injector }, { type: ComponentFactoryResolver } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/components/tooltip/tooltip.component.ts